<template>
  <div style="width: 100%;height: 100%;background-color: white;">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
      <el-row style="height: 100%">
        <el-col :span="4" style="height: 100%;overflow-y: auto">
          <div style="margin: 0 20px;height: 50px">
            <el-input
              prefix-icon="el-icon-search"
              placeholder="输入搜索组织"
              v-model="filterText"
              clearable
            >
            </el-input>
          </div>
          <div style="margin: 0 20px;">
            <el-tree class="filter-tree"
                     highlight-current
                     :data="treeData"
                     :props="defaultProps"
                     node-key="id"
                     :current-node-key="currentNodeKey"
                     :default-expanded-keys="expandedKeys"
                     @node-click="handleTreeClick"
                     :filter-node-method="filterNode"
                     ref="treeData">
            </el-tree>
          </div>
        </el-col>
        <el-col :span="20" style="height: 100%;overflow-y: auto">
          <div>
            <div style="height: 40px;width: 100%;">
              <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
                <span>{{item.name}}</span>
              </div>
            </div>
            <div v-if="indexActive === 0">
              <div style="height: 40px">
                <el-button size="small" type="primary" plain icon="el-icon-plus" @click="addFM()">新增</el-button>
              </div>
              <org-fm-info ref="fm" :fmObj="fmObj"></org-fm-info>
            </div>
            <div v-if="indexActive === 1">
              <voice-org ref="voice"></voice-org>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {queryorg} from '../../api/organizer'
import orgFmInfo from './orgComponents/orgFmInfo'
import voiceOrg from './deviceComponents/voiceOrg'
export default {
  name: 'deviceSet',
  components: {orgFmInfo, voiceOrg},
  data () {
    return {
      orgData: [],
      // 左边
      orgObj: '',
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      expandedKeys: [],
      currentNodeKey: '',
      tabs: [
        {index: 0, name: 'FM频率设置'},
        {index: 1, name: '语音通知设置'}
      ],
      indexActive: 0,
      fmObj: {
        type: 'deviceSet',
        orgRow: ''
      }
    }
  },
  created () {
  },
  mounted () {
    this.getOrgData()
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    handleTreeClick (val) {
      // console.log(val)
      this.orgObj = val
      let vm = this
      setTimeout(() => {
        if (this.indexActive === 0) {
          vm.$refs.fm.getFMObj(this.orgObj)
        } else if (this.indexActive === 1) {
          let obj = {
            orgData: this.orgData,
            orgObj: this.orgObj
          }
          vm.$refs.voice.getVoice(obj)
        }
      }, 200)
    },
    // 组织
    getOrgData () {
      this.expandedKeys = []
      this.treeData = []
      queryorg().then(res => {
        this.orgData = res.data.org.filter(item => {
          if (item.org_type === 0) {
            return item
          }
        })
        for (let i = 0; i < this.orgData.length; i++) {
          if (this.orgData[i].orgpid === -1) {
            this.expandedKeys.push(this.orgData[i].id)
          }
        }
        // 所属组织
        let lastLevel = 100
        const arr = this.orgData
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.treeData.length; i++) {
          if (this.expandedKeys.length === 0) {
            this.expandedKeys.push(this.treeData[i].id)
          }
          const child = this.arrayToNode(arr, this.treeData[i].id)
          if (child.length !== 0) {
            this.treeData[i].child = child
          }
        }
        this.currentNodeKey = this.treeData[0].id
        // this.fmObj.orgRow = this.treeData[0]
        this.orgObj = this.treeData[0]
        this.$refs.fm.getFMObj(this.treeData[0])
        this.$nextTick(() => {
          this.$refs.treeData.setCurrentKey(this.currentNodeKey) // 一定要加这个选中了否则样式没有出来
        })
      }).catch(() => {})
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    selectTab (item) {
      if (this.indexActive === item.index) {
        return
      }
      this.indexActive = item.index
      let vm = this
      setTimeout(() => {
        if (this.indexActive === 0) {
          vm.$refs.fm.getFMObj(this.orgObj)
        } else if (this.indexActive === 1) {
          let obj = {
            orgData: this.orgData,
            orgObj: this.orgObj
          }
          vm.$refs.voice.getVoice(obj)
        }
      }, 200)
    },
    addFM () {
      this.$refs.fm.addShow()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceSet.vue